import { useFeatureFlags as useFeatureFlagsContext } from '../../contexts/FeatureFlagContext'

export const useFeatureFlags = useFeatureFlagsContext
